import { render, staticRenderFns } from "./GridManifestComponent.vue?vue&type=template&id=3b2f0000&"
import script from "./GridManifestComponent.vue?vue&type=script&lang=js&"
export * from "./GridManifestComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports